<template>
  <!-- 单品方案设计 -->
  <div class="addPromRule">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title + ' ' + typeData[addForm.type]">
      <template slot="controls">
        <el-link @click="explain = true" style="margin-right: 10px;" icon="el-icon-question" :underline="false"
          type="warning">操作说明</el-link>
      </template>
    </page-header>
    <!-- 表单容器 -->
    <el-scrollbar style="
        width: 100%;
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      ">
      <el-form :model="addForm" label-position="right" label-width="140px" :rules="addFormRule" ref="addForm">
        <div class="form-item-wrap">
          <el-form-item label="方案名称" prop="name">
            <el-input v-model="addForm.name" style="width: 200px"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="促销类型" prop="type">
            <el-select v-model="addForm.type" placeholder="促销类型" style="width: 200px; margin-right: 5px" disabled>
              <el-option label="换购" value="DHG"></el-option>
              <el-option label="买赠" value="DMZ"></el-option>
              <el-option label="折扣" value="DZK"></el-option>
              <el-option label="抢购" value="DQG"></el-option>
              <el-option label="满减" value="DMJ"></el-option>
              <el-option label="组合" value="GZH"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="form-item-wrap">
          <el-form-item label="促销描述" prop="des">
            <el-input v-model="addForm.des" style="width: 200px"></el-input>
            <span>（将会显示在商品详情界面）</span>
          </el-form-item>
        </div>

        <div class="form-item-wrap">
          <el-form-item label="客户类型" prop="userType">
            <el-checkbox-group v-model="addForm.userType" style="width: 1000px">
              <el-checkbox v-for="item in userTypeList" :key="item.value" :label="item.value">
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>

        <!-- 非抢购和组合可选择商品范围类型，否则默认全部商品 -->
        <div class="form-item-wrap" v-show="addForm.type != 'DQG' && addForm.type != 'GZH'">
          <el-form-item label="商品范围" prop="goodsRange">
            <el-select v-model="addForm.goodsRange" placeholder="商品范围" style="width: 200px" @change="goodsRangeChange">
              <el-option label="全部商品" value="0"></el-option>
              <el-option label="分类商品" value="1"></el-option>
              <el-option label="品牌商品" value="2"></el-option>
              <el-option label="独立商品" value="3"></el-option>
              <el-option label="商品分组" value="4"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <!-- 抢购和组合显示 -->
        <div class="form-item-wrap" v-show="
          addForm.goodsRange != 0 &&
          addForm.type != 'DQG' &&
          addForm.type != 'GZH'
        ">
          <el-form-item label="活动商品" prop="goodsRangeData" class="el-form-required-true">
            <el-table :data="goodsRangeList" stripe border tooltip-effect="dark" style="
                width: 1000px;
                border: 1px solid #ebeef5;
                border-bottom: none;
              ">
              <el-table-column label="序号" align="center" width="50">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="name" show-overflow-tooltip :label="goodsRangeData.label + '名称'">
                <template slot-scope="scope">
                  <el-input v-if="scope.$index == 0" readonly v-model="addForm.goodsRangeData.name" class="tac-inp"
                    style="width: 90%" @click.native="getRangeData" placeholder="单击选择"></el-input>
                  <span v-else>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="allNum" show-overflow-tooltip v-if="addForm.goodsRange == 3"
                label="促销商品总数量">
                <template slot-scope="scope">
                  <el-input-number v-if="scope.$index == 0" v-model="addForm.goodsRangeData.allNum" :min="1"
                    :max="100000000" style="width: 90%"></el-input-number>
                  <span v-else>{{ scope.row.allNum }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="limitNum" show-overflow-tooltip v-if="addForm.goodsRange == 3"
                label="客户限购数量">
                <template slot-scope="scope">
                  <el-input-number v-if="scope.$index == 0" v-model="addForm.goodsRangeData.limitNum" :min="0"
                    :max="100000000" style="width: 90%"></el-input-number>
                  <span v-else>{{ scope.row.limitNum }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="minNum" show-overflow-tooltip v-if="addForm.goodsRange == 3"
                label="客户起购数量">
                <template slot-scope="scope">
                  <el-input-number v-if="scope.$index == 0" v-model="addForm.goodsRangeData.minNum" :min="1"
                    :max="100000000" style="width: 90%"></el-input-number>
                  <span v-else>{{ scope.row.minNum }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="160">
                <template slot-scope="scope">
                  <el-button type="primary" style="padding: 2px 3px" plain @click="addRangeData"
                    v-if="scope.$index == 0">确定</el-button>
                  <el-button type="danger" style="padding: 2px 3px" plain @click="delRangeData(scope.$index)" v-else>删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </div>

        <div class="form-item-wrap" v-show="addForm.type != 'DQG' && addForm.type != 'GZH'">
          <el-form-item label="促销模式" prop="mode">
            <el-radio-group v-model="addForm.mode" @change="setSatisfy">
              <el-radio label="1">满足金额</el-radio>
              <el-radio label="0" v-show="addForm.type != 'DMJ'">满足数量</el-radio>
              <el-radio label="0" v-show="addForm.type == 'DMJ'">满足数量减金额</el-radio>
              <el-radio label="2" v-show="addForm.type == 'DMJ'">满足数量减单价</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

        <!-- 满减、满赠、换购显示是否累加 -->
        <div class="form-item-wrap" v-show="addForm.type == 'DMJ' || addForm.type == 'DMZ' || addForm.type == 'DHG'">
          <el-form-item label="是否累加" prop="isAdd">
            <el-radio-group v-model="addForm.isAdd">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

        <div class="form-item-wrap">
          <el-form-item :label="
            addForm.type == 'DQG' || addForm.type == 'GZH'
              ? '活动商品'
              : '促销满足条件'
          " prop="satisfy" class="el-form-required-true">
            <!-- 如果是买赠而且有加入商品的话显示 -->
            <el-table v-show="
              (addForm.type == 'DMZ' && satisfyList.length < 2) ||
              addForm.type != 'DMZ' ||
              addForm.isAdd == 0
            " :data="satisfyList" stripe border tooltip-effect="dark" style="
                width: 1000px;
                border: 1px solid #ebeef5;
                border-bottom: none;
              ">
              <el-table-column label="序号" align="center" width="50">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column v-for="(value, key) in satisfyHead" align="center" :key="key" show-overflow-tooltip
                :label="value">
                <template slot-scope="scope">
                  <el-input v-if="scope.$index == 0 && satisfyHeadType[key] == 'inp'" v-model="addForm.satisfy[key]"
                    style="width: 90%" class="tac-inp"></el-input>
                  <el-input v-else-if="
                    scope.$index == 0 && satisfyHeadType[key] == 'read'
                  " readonly v-model="addForm.satisfy[key]" style="width: 90%" class="tac-inp"
                    @click.native="getSatisfyData" placeholder="单击选择"></el-input>
                  <el-input-number v-else-if="
                    scope.$index == 0 && satisfyHeadType[key] == 'num'
                  " v-model="addForm.satisfy[key]" :min="0" :max="100000000" style="width: 90%"></el-input-number>
                  <span v-else>{{ scope.row[key] }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="160">
                <template slot-scope="scope">
                  <el-button type="primary" style="padding: 2px 3px" plain @click="addSatisfyData"
                    v-if="scope.$index == 0">确定</el-button>
                  <el-button type="danger" style="padding: 2px 3px" plain @click="delSatisfyData(scope.$index)" v-else>
                    删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 创建一个表格，在选中累加的时候和添加了一条数据的时候显示 -->
            <div v-if="addForm.type == 'DMZ'">
              <el-table v-show="satisfyList.length >= 2 && addForm.isAdd == 1" :data="satisfyList.slice(1)" stripe
                border tooltip-effect="dark" style="
                  width: 1000px;
                  border: 1px solid #ebeef5;
                  border-bottom: none;
                ">
                <el-table-column label="序号" align="center" width="50">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-for="(value, key) in satisfyHead" align="center" :key="key" show-overflow-tooltip
                  :label="value">
                  <template slot-scope="scope">
                    <span>{{ scope.row[key] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="160">
                  <template slot-scope="scope">
                    <el-button type="danger" style="padding: 2px 3px" plain @click="delSatisfyData(scope.$index)">删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </div>

        <div class="form-item-wrap" v-show="
          addForm.goodsRange != 3 &&
          addForm.type != 'DQG' &&
          addForm.type != 'GZH'
        ">
          <el-form-item label="促销商品总数量" prop="allNum" class="el-form-required-true">
            <el-input-number v-model="addForm.allNum" :min="1" :max="100000000" style="width: 200px"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap" v-show="
          addForm.goodsRange != 3 &&
          addForm.type != 'DQG' &&
          addForm.type != 'GZH'
        ">
          <el-form-item label="客户限购数量" prop="limitNum" class="el-form-required-true">
            <el-input-number v-model="addForm.limitNum" :min="0" :max="100000000"
              style="width: 200px"></el-input-number>
          </el-form-item>
        </div>

        <div class="form-item-wrap" v-show="addForm.type == 'GZH'">
          <el-form-item label="促销商品组总数量" prop="allNum" class="el-form-required-true">
            <el-input-number v-model="addForm.allNum" :min="1" :max="100000000" style="width: 200px"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap" v-show="addForm.type == 'GZH'">
          <el-form-item label="客户限购组数量" prop="limitNum" class="el-form-required-true">
            <el-input-number v-model="addForm.limitNum" :min="0" :max="100000000"
              style="width: 200px"></el-input-number>
          </el-form-item>
        </div>

        <div class="form-item-wrap">
          <el-form-item label="区域控销" prop="limitArea">
            <el-select v-model="addForm.limitArea" placeholder="区域控销" style="width: 200px; margin-right: 5px">
              <el-option label="无限制" value="0"></el-option>
              <el-option label="指定白名单" value="1"></el-option>
              <el-option label="指定黑名单" value="2"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="form-item-wrap" v-show="addForm.limitArea != 0">
          <el-form-item label="选择区域" prop="areaValue">
            <div style="width: 800px">
              <div>
                <el-tag v-for="(item, index) in areaList" :key="index" closable
                  @close="tagClose(index, 'areaValue', 'areaList')" type="success" effect="dark"
                  :disable-transitions="false" class="my-el-tag" style="margin-bottom: 5px">{{ item.label }}
                </el-tag>
              </div>
              <el-button type="primary" @click="setTableData('area')">增加区域</el-button>
            </div>
          </el-form-item>
        </div>

        <div class="form-item-wrap">
          <el-form-item label="客户控销" prop="customerLimit">
            <el-select v-model="addForm.customerLimit" placeholder="请选择" style="width: 200px; margin-right: 5px">
              <el-option label="无限制" :value="0"></el-option>
              <el-option label="指定白名单" :value="1"></el-option>
              <el-option label="指定黑名单" :value="2"></el-option>
            </el-select>
            <el-select v-if="addForm.customerLimit != 0" v-model="addForm.customerGroup" placeholder="请选择"
              style="width: 200px" filterable clearable multiple>
              <el-option v-for="item in groupList" :key="item.GroupId" :label="item.GroupName" :value="item.GroupId">
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="form-item-wrap">
          <el-form-item label="" prop="">
            <el-button v-if="status == 1" size="medium" type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>

    <!-- 商品范围选择信息 -->
    <el-dialog :title="goodsRangeData.title" :visible.sync="dialogVisible"
      :close-on-click-modal="$store.state.closeOnClickModal" :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%">
      <search-bar>
        <template>
          <el-input style="width: 200px; margin-right: 5px" clearable placeholder="输入编号/名称" v-model="searchForm.name">
          </el-input>
          <el-button type="primary" icon="el-icon-search" @click="getRangeData">搜索</el-button>
        </template>
      </search-bar>
      <el-table :data="goodsRangeListData" stripe border @row-click="rowClick" tooltip-effect="dark" height="300px">
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column v-for="(value, key) in goodsRangeListHead" align="center" :key="key" show-overflow-tooltip
          :label="value">
          <template slot-scope="scope">
            <span>{{ scope.row[key] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage" @hanCurrChange="hanCurrChange"
        layout="total, prev, pager, next, jumper"></pagination>
    </el-dialog>

    <!-- 满足条件选择 -->
    <el-dialog :title="satisfyData.title + '列表'" :visible.sync="satisfyVisible"
      :close-on-click-modal="$store.state.closeOnClickModal" :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%">
      <search-bar>
        <template>
          <el-input style="width: 200px; margin-right: 5px" clearable placeholder="输入编号/名称"
            v-model="satisfySearch.name"></el-input>
          <el-button type="primary" icon="el-icon-search" @click="getSatisfyData">搜索</el-button>
        </template>
      </search-bar>
      <el-table :data="satisfyListData" stripe border @row-click="rowSatisfy" tooltip-effect="dark" height="300px">
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{
            (currPageSatisfy - 1) * pageSizeSatisfy + scope.$index + 1
            }}</span>
          </template>
        </el-table-column>
        <el-table-column v-for="(value, key) in satisfyListDataHead" align="center" :key="key" show-overflow-tooltip
          :label="value">
          <template slot-scope="scope">
            <span>{{ scope.row[key] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :allPage="allPageSatisfy" :pageSize="pageSizeSatisfy" :currIndex="currPageSatisfy"
        @hanCurrChange="hanCurrChangeSatisfy" layout="total, prev, pager, next, jumper"></pagination>
    </el-dialog>

    <!-- 数据选择 -->
    <tableDialog v-if="isShowLimit" :title="tableData.title" :isMoreSel="tableData.isAllSel"
      :searchValue="tableData.searchForm.name" :tableData="tableList" :tableHead="tableDataHead"
      :currPage.sync="currPageLimit" :allPage="allPageLimit" @search="getTableData" @moreSel="selDataOk"
      @rowClick="rowClickLimit" @hanCurrChange="hanCurrChangeLimit" @close="isShowLimit = false"></tableDialog>

    <el-dialog title="操作说明" :visible.sync="explain" :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape" width="70%">
      <el-scrollbar class="explain-text">
        <p>规则维护说明</p>
        <div>
          <p>组合：</p>
          <p>1、方案名称、促销描述自定义填写，促销描述一般显示在商品详情和购物车列表中</p>
          <p>2、客户类型：参与活动的客户类型</p>
          <p>3、活动商品选项用来设置一个组中包含的商品，一般为两个或者多个</p>
          <p>4、促销商品组总数量</p>
          <p>5、客户限购组数量</p>
          <p>6、设置区域控销白名单黑名单</p>
          <p>7、设置客户控销白名单黑名单，客户分组在<span style="font-weight: bold;">客户管理 -> 客服分组</span>中维护</p>
          <p>8、保存数据</p>
          <p>9、上架</p>
          <p>10、<span style="font-weight: bold;">促销活动管理</span>中设置促销活动</p>
        </div>
        <div>
          <p>折扣：禁用该促销规则，禁用后该规则可进行编辑</p>
          <p>1、方案名称、促销描述、客户类型设置和组合活动一致，以下不再赘述</p>
          <p>2、商品范围：可选择不同类型的商品，全部商品代表商城中所有已上架的商品；分类商品可选择绑定<span
              style="font-weight: bold;">二级分类</span>的商品；品牌商品可直接选择商品品牌，选中品牌下的商品参与活动；独立商品：可单独选择某个或某些商品参与活动</p>
          <p>3、促销模式：可选择满足指定金额或者满足指定数量</p>
          <p>4、促销满足条件：满足折扣的具体条件，折扣100代表没有折扣，97代表九七折</p>
          <p>5、设置区域控销->客户控销->保存->上架->设置促销活动</p>
        </div>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "addPromRule",
  data() {
    return {
      status: "2",//促销规则的状态 2启用 1禁用
      id: "",
      entid: "",
      typeData: {
        DHG: "换购",
        DMZ: "买赠",
        DZK: "折扣",
        DQG: "抢购",
        DMJ: "满减",
        GZH: "组合",
      },
      /**新增表单 */
      addForm: {
        name: "", // 方案名称
        type: "", // 促销类型
        des: "", // 促销描述
        userType: [], // 客户类型
        goodsRange: "0", // 商品范围
        // 全部商品
        allNum: "1", // 促销商品总数量
        limitNum: "1", // 客户限购数量
        // 商品范围 包括分类，品牌，独立商品
        goodsRangeData: {
          id: "", // 分类ID
          name: "", // 分类名称
          allNum: "1", // 促销商品总数量
          limitNum: "1", // 客户限购数量
          minNum: "1", // 客户起购数量
        },
        mode: "0", // 促销模式
        isAdd: "0", // 是否累加
        satisfy: {}, // 促销满足条件
        limitArea: "0", // 区域控销
        areaValue: "", // 选择区域
        customerLimit: 0, //是黑名单还是白名单
        customerGroup: [], //客户列表id
      },
      groupList: [], //客户分组列表
      /**表单规则 */
      addFormRule: {
        name: [mustFill],
        type: [mustFill],
        userType: [mustFill],
        goodsRange: [mustFill],
        allNum: [this.goodsRangeFill(0)],
        limitNum: [this.goodsRangeFill(0)],
        mode: [mustFill],
        isAdd: [mustFill],
        // limitArea: [mustFill], // 区域控销
        // areaValue: [this.limitFill("limitArea")], // 选择区域
      },
      // 商品范围列表 包括分类，品牌，独立商品
      goodsRangeList: [
        {
          id: "", // ID
          name: "", // 名称
          allNum: "1", // 促销商品总数量
          limitNum: "1", // 客户限购数量
          minNum: "1", // 客户起购数量
        },
      ],
      // 商品范围列表数据
      goodsRangeListData: [],
      goodsRangeListHead: {},
      dialogVisible: false,
      currPage: 1,
      pageSize: 10,
      allPage: 0,
      searchForm: {
        name: "",
      },
      goodsRangeData: {
        label: "",
        title: "",
        type: "",
        key: "",
      },
      // 促销满足条件
      satisfyList: [],
      satisfyListData: [],
      satisfyListDataHead: {},
      satisfyInit: {},
      satisfyHead: {},
      satisfyHeadType: {},
      satisfyVisible: false,
      satisfySearch: {
        name: "",
      },
      satisfyData: {
        label: "",
        title: "",
        type: "",
        key: "",
      },
      currPageSatisfy: 1,
      pageSizeSatisfy: 10,
      allPageSatisfy: 0,
      // 用户类型列表
      userTypeList: [],
      // 表格多选时是否有已选的数据
      isShowLimit: false,
      isSelDataOkRep: false,
      currPageLimit: 1,
      allPageLimit: 0,
      areaList: [],
      tableData: {
        searchForm: {
          name: "",
        },
        type: "",
        title: "",
        sqlType: "",
        key: "",
        isAllSel: false,
      },
      tableList: [],
      tableDataHead: {},

      /**使用说明 */
      explain: false
    };
  },
  mounted() {
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams.type) {
      this.addForm.type = prams.type;
    }

    if ('status' in prams) {
      this.status = prams.status;
    }

    if (prams.id) {
      this.id = prams.id;
      this.entid = prams.entid;
      this.getPromRule(); //获取促销规则数据
    }
    this.getUserType(); //获取会员类型
    this.setSatisfy(); // 设置促销
    this.getGroupList(); //获取客户列表
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },

    // 获取促销规则详情数据
    getPromRule() {
      let data = {
        type: "QuerySingleProm",
        entid: this.entid,
        ruleCode: this.id,
      };
      this.$requestSys({
        method: "post",
        url:
          "prom/ashx/PromRule.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)),
      })
        .then((res) => {
          if (res.flag == 0) {
            let promRule = res.promRule;
            this.addForm.name = promRule.ruleTitle;
            this.addForm.des = promRule.describe;
            this.addForm.userType = this.$changeStrArr(promRule.customerType);
            this.addForm.goodsRange = promRule.PromScenario;
            this.addForm.allNum = promRule.Amount;
            this.addForm.limitNum = promRule.limitAmount;
            this.addForm.mode = promRule.contentType;
            this.addForm.isAdd = promRule.moreBuy;

            //遍历出控销区域数据
            if (res.AreaList.length > 0) {
              this.addForm.limitArea = res.AreaList[0].Limit + "" || "0";
              // 这个是tag遍历的数据
              this.areaList = res.AreaList.map((item) => {
                return {
                  label: item.LimitName,
                  value: item.LimitCode,
                };
              });
              //需要生成组合好的数据
              this.addForm.areaValue = res.AreaList.map(
                (item) => item.LimitCode
              ).join();
            }

            // 遍历出客户控销数据
            if (res.ClientList.length > 0) {
              this.addForm.customerLimit = res.ClientList[0].Limit;
              this.addForm.customerGroup = res.ClientList.map((item) => {
                return parseInt(item.LimitCode);
              });
            }

            // let valueList = this.$changeStrArr(promRule.AreaControlCode);
            // let labelList = this.$changeStrArr(promRule.AreaControlName);
            // this.areaList = valueList.map((item, index) => ({
            //   label: labelList[index],
            //   value: valueList[index],
            // }));

            this.goodsRangeChange();
            this.setSatisfy();
            if (this.addForm.type == "DQG") {
              let list = res.replenishes.map((item, index) => ({
                id: item.ScnarioID,
                goods: this.changeStr(item.SecnarioName),
                price: res.conditions[index].giftPrice,
                allNum: item.maxQuantity,
                needNum: res.conditions[index].meetCount,
                limitNum: item.limitQuantity,
              }));
              this.satisfyList = this.satisfyList.concat(list);
            } else if (this.addForm.type == "GZH") {
              let list = res.replenishes.map((item, index) => ({
                id: item.ScnarioID,
                goods: this.changeStr(item.SecnarioName),
                price: res.conditions[index].giftPrice,
                allNum: res.conditions[index].giftQuantity,
              }));
              this.satisfyList = this.satisfyList.concat(list);
            } else {
              let goodsRangeList = res.replenishes.map((item) => ({
                id: item.ScnarioID,
                name: this.changeStr(item.SecnarioName),
                allNum: item.maxQuantity,
                limitNum: item.limitQuantity,
                minNum: item.minQuantity,
              }));
              if (this.addForm.goodsRange == 4) {
                // goodsRangeList = res.replenishes.map((item,index) => {
                //   let list = item.ScnarioID.split('_')
                //   this.getGroupName(list[0], index + 1)
                //   return {
                //     id: list[0],
                //     name: '',
                //     allNum: list[1],
                //     limitNum: list[2],
                //     minNum: list[3],
                //   }
                // })
                goodsRangeList.forEach((item, index) => {
                  this.getGroupName(item.id, index + 1);
                });
              }
              this.goodsRangeList = this.goodsRangeList.concat(goodsRangeList);
              let list = {};
              if (this.addForm.type == "DZK") {
                list = res.conditions.map((item) => ({
                  needNum: item.meetCount,
                  discount: item.discount,
                }));
              } else if (this.addForm.type == "DMJ") {
                list = res.conditions.map((item) => ({
                  needNum: item.meetCount,
                  price: item.giftPrice,
                }));
              } else if (this.addForm.type == "DMZ") {
                list = res.conditions.map((item) => ({
                  id: item.giftGoodsID,
                  needNum: item.meetCount,
                  gift: item.giftName,
                  num: item.giftQuantity,
                  price: item.giftPrice,
                }));
              } else if (this.addForm.type == "DHG") {
                list = res.conditions.map((item) => ({
                  id: item.giftGoodsID,
                  needNum: item.meetCount,
                  goods: item.giftName,
                  num: item.giftQuantity,
                  price: item.giftPrice,
                }));
              }
              this.satisfyList = this.satisfyList.concat(list);
            }
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 字符串转化
    changeStr(str) {
      if (str && str.indexOf("&nbsp;") != -1) {
        str = str.split("&nbsp;")[0].split("：")[1];
      }
      return str;
    },
    // 获取分组名称
    getGroupName(id, index) {
      let data = {
        type: "GetPromGoodsGroup",
        status: "99",
        strWhere: id,
        PageIndex: 1,
        PageSize: 20,
      };
      let proc = "Proc_PromGoodsGroup"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "prom/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.goodsRangeList[index].name = res.data[0].GroupName;
          } else {
            this.$message({
              message: res.message,
              type: 'warning'
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取会员类型
    getUserType() {
      let data = {
        type: "CustomType",
      };
      let proc = "Proc_Admin_CustomerList"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.userTypeList = res.data.map((item) => {
              return {
                label: item.clienttype,
                value: item.TypeID,
              };
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 商品范围控制
    goodsRangeFill(type) {
      return {
        validator: (rule, value, callback) => {
          if (
            (this.addForm.goodsRange == type && this.addForm.type != "DQG") ||
            (this.addForm.goodsRange == 3 && this.addForm.type == "GZH")
          ) {
            if (!value) {
              return callback(new Error("该字段为必填项"));
            } else {
              return callback();
            }
          } else {
            return callback();
          }
        },
      };
    },

    /* 商品范围弹窗相关 */
    // 商品范围相关数据初始化
    goodsRangeInit() {
      this.currPage = 1;
      this.searchForm.name = "";
      this.goodsRangeList = [
        { id: "", name: "", allNum: 1, limitNum: 1, minNum: 1 },
      ];
      this.addForm.goodsRangeData = {
        id: "",
        name: "",
        allNum: 1,
        limitNum: 1,
        minNum: 1,
      };
    },

    /**选择活动商品，获取商品范围对应数据 */
    goodsRangeChange() {
      let val = this.addForm.goodsRange;
      if (val == 1) {
        this.goodsRangeData.label = "分类";
        this.goodsRangeData.title = "商品分类(二级分类)";
        this.goodsRangeData.type = "CategrysListHG";
        this.goodsRangeData.key = "分类";
        this.goodsRangeInit();
      } else if (val == 2) {
        this.goodsRangeData.label = "品牌";
        this.goodsRangeData.title = "品牌列表";
        this.goodsRangeData.type = "goodsBrand";
        this.goodsRangeData.key = "name";
        this.goodsRangeInit();
      } else if (val == 3) {
        this.goodsRangeData.label = "商品";
        this.goodsRangeData.title = "商品列表";
        this.goodsRangeData.type = "GoodsList";
        this.goodsRangeData.key = "sub_title";
        this.goodsRangeInit();
      } else if (val == 4) {
        this.goodsRangeData.label = "分组";
        this.goodsRangeData.title = "分组列表";
        this.goodsRangeData.type = "GoodsGroup";
        this.goodsRangeData.key = "name";
        this.goodsRangeInit();
      }
    },

    getRangeData() {
      let data = {
        type: this.goodsRangeData.type,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
        strWhere: this.searchForm.name,
      };
      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      let url =
        "ashx/MainReturnJson.ashx?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&type=" +
        type +
        "&proc=" +
        proc;
      if (this.goodsRangeData.type == "GoodsGroup") {
        data = {
          type: "GetPromGoodsGroup",
          status: "2",
          strWhere: this.searchForm.name,
          PageIndex: this.currPage,
          PageSize: this.pageSize,
        };
        proc = "Proc_PromGoodsGroup"; //存储过程名
        type = "ReturnList";
        url =
          "prom/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc;
      }
      this.$requestSys({
        method: "post",
        url: url,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.goodsRangeListData = res.content;
            this.goodsRangeListHead = res.fdname;
            if (this.goodsRangeData.type == "GoodsGroup") {
              this.goodsRangeListData = res.data.map((item) => ({
                keyid: item.GroupId,
                entName: item.entname,
                name: item.GroupName,
                type: item.Genre,
                num: item.GoodsCount,
                time: item.addTime,
              }));
              this.goodsRangeListHead = {
                keyid: "分组编号",
                entName: "机构名称",
                name: "分组名称",
                type: "分组类型",
                num: "商品数量",
                time: "创建时间",
              };
            }
            this.allPage = res.recordCount;
            this.dialogVisible = true;
          } else {
            this.$message({
              message: res.message,
              type: 'warning'
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getRangeData();
    },
    // 单击弹框数据
    rowClick(row) {
      let key = "keyid";
      if (this.goodsRangeData.label == "品牌") {
        key = "billno";
      }
      // for (let i = 0; i < this.goodsRangeList.length; i++) {
      //   if (this.goodsRangeList[i].id == row[key]) {
      //     this.$message({
      //       message: "选择的数据已在列表中",
      //       type: "warning",
      //     });
      //     return;
      //   }
      // }
      this.addForm.goodsRangeData.id = row[key];
      this.addForm.goodsRangeData.name = row[this.goodsRangeData.key] || " ";
      this.dialogVisible = false;
    },
    // 增加分类数据
    addRangeData() {
      if (!this.addForm.goodsRangeData.id) {
        this.$message({
          message: "请选择" + this.goodsRangeData.label,
          type: "warning",
        });
        return;
      }
      this.goodsRangeList.push(this.addForm.goodsRangeData);
      this.addForm.goodsRangeData = {
        id: "",
        name: "",
        allNum: 1,
        limitNum: 1,
        minNum: 1,
      };
    },
    // 删除分类数据
    delRangeData(index) {
      this.goodsRangeList.splice(index, 1);
    },
    /* 促销满足条件相关 */
    // 设置促销满足条件相关数据
    setSatisfy() {
      if (this.addForm.type == "DZK") {
        if (this.addForm.mode == 1) {
          this.satisfyInit = { needNum: 0, discount: 100 };
          this.satisfyHead = { needNum: "满足金额", discount: "折扣" };
          this.satisfyHeadType = { needNum: "num", discount: "num" };
        } else if (this.addForm.mode == 0) {
          this.satisfyInit = { needNum: 0, discount: 100 };
          this.satisfyHead = { needNum: "满足数量", discount: "折扣" };
          this.satisfyHeadType = { needNum: "num", discount: "num" };
        }
      } else if (this.addForm.type == "DMJ") {
        if (this.addForm.mode == 1) {
          this.satisfyInit = { needNum: 0, price: 0 };
          this.satisfyHead = { needNum: "满足金额", price: "金额" };
          this.satisfyHeadType = { needNum: "num", price: "num" };
        } else if (this.addForm.mode == 0) {
          this.satisfyInit = { needNum: 0, price: 0 };
          this.satisfyHead = { needNum: "满足数量", price: "金额" };
          this.satisfyHeadType = { needNum: "num", price: "num" };
        } else if (this.addForm.mode == 2) {
          this.satisfyInit = { needNum: 0, price: 0 };
          this.satisfyHead = { needNum: "满足数量", price: "减少的单价" };
          this.satisfyHeadType = { needNum: "num", price: "num" };
        }
      } else if (this.addForm.type == "DMZ") {
        if (this.addForm.mode == 1) {
          this.satisfyInit = { id: "", needNum: 0, gift: "", num: 0, price: 0 };
          this.satisfyHead = {
            needNum: "满足金额",
            gift: "赠品",
            num: "数量",
            price: "金额",
          };
          this.satisfyHeadType = {
            needNum: "num",
            gift: "read",
            num: "num",
            price: "num",
          };
        } else if (this.addForm.mode == 0) {
          this.satisfyInit = { id: "", needNum: 0, gift: "", num: 0, price: 0 };
          this.satisfyHead = {
            needNum: "满足数量",
            gift: "赠品",
            num: "数量",
            price: "金额",
          };
          this.satisfyHeadType = {
            needNum: "num",
            gift: "read",
            num: "num",
            price: "num",
          };
        }
        this.satisfyData.type = "GoodsListMZ";
        this.satisfyData.title = "赠品";
        this.satisfyData.label = "gift";
        this.satisfyData.key = "goodsname";
      } else if (this.addForm.type == "DHG") {
        if (this.addForm.mode == 1) {
          this.satisfyInit = {
            id: "",
            needNum: 0,
            goods: "",
            num: 0,
            price: 0,
          };
          this.satisfyHead = {
            needNum: "满足金额",
            goods: "换购商品",
            num: "数量",
            price: "金额",
          };
          this.satisfyHeadType = {
            needNum: "num",
            goods: "read",
            num: "num",
            price: "num",
          };
        } else if (this.addForm.mode == 0) {
          this.satisfyInit = {
            id: "",
            needNum: 0,
            goods: "",
            num: 0,
            price: 0,
          };
          this.satisfyHead = {
            needNum: "满足数量",
            goods: "换购商品",
            num: "数量",
            price: "金额",
          };
          this.satisfyHeadType = {
            needNum: "num",
            goods: "read",
            num: "num",
            price: "num",
          };
        }
        this.satisfyData.type = "GoodsListHG";
        this.satisfyData.title = "商品";
        this.satisfyData.label = "goods";
        this.satisfyData.key = "sub_title";
      } else if (this.addForm.type == "DQG") {
        this.satisfyInit = {
          id: "",
          goods: "",
          price: 0,
          allNum: 0,
          needNum: 0,
          limitNum: 0,
        };
        this.satisfyHead = {
          goods: "商品名称",
          price: "促销价",
          allNum: "参与活动数量",
          needNum: "满足数量",
          limitNum: "限购数量",
        };
        this.satisfyHeadType = {
          goods: "read",
          price: "num",
          allNum: "num",
          needNum: "num",
          limitNum: "num",
        };
        // this.satisfyData.type = "GoodsListHG";
        this.satisfyData.type = "GoodsList";
        this.satisfyData.title = "商品";
        this.satisfyData.label = "goods";
        this.satisfyData.key = "sub_title";
      } else if (this.addForm.type == "GZH") {
        this.satisfyInit = { id: "", goods: "", allNum: 0, price: 0 };
        this.satisfyHead = {
          goods: "商品名称",
          allNum: "数量",
          price: "促销价",
        };
        this.satisfyHeadType = { goods: "read", allNum: "num", price: "num" };
        // this.satisfyData.type = "GoodsListHG";
        this.satisfyData.type = "GoodsList";
        this.satisfyData.title = "商品";
        this.satisfyData.label = "goods";
        this.satisfyData.key = "sub_title";
      }
      this.addForm.satisfy = JSON.parse(JSON.stringify(this.satisfyInit));
      this.satisfyList = [JSON.parse(JSON.stringify(this.satisfyInit))];
    },
    // 获取商品满足条件弹窗数据
    getSatisfyData() {
      let data = {
        type: this.satisfyData.type,
        PageIndex: this.currPageSatisfy,
        PageSize: this.pageSizeSatisfy,
        strWhere: this.satisfySearch.name,
      };
      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.satisfyListData = res.content;
            this.satisfyListDataHead = res.fdname;
            this.allPageSatisfy = res.recordCount;
            this.satisfyVisible = true;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    hanCurrChangeSatisfy(val) {
      this.currPageSatisfy = val;
      this.getSatisfyData();
    },
    rowSatisfy(row) {
      // 去除重复数据判断
      // for (let i = 0; i < this.satisfyList.length; i++) {
      //   if (this.satisfyList[i].id == row.keyid) {
      //     this.$message({
      //       message: "选择的数据已在列表中",
      //       type: "warning",
      //     });
      //     return;
      //   }
      // }
      this.addForm.satisfy.id = row.keyid;
      this.addForm.satisfy[this.satisfyData.label] = row[this.satisfyData.key];
      this.satisfyVisible = false;
    },
    // 增加促销条件
    addSatisfyData() {
      if (this.addForm.satisfy.id === "") {
        this.$message({
          message: "请选择" + this.satisfyData.title,
          type: "warning",
        });
        return;
      }
      this.satisfyList.push(this.addForm.satisfy);
      this.addForm.satisfy = JSON.parse(JSON.stringify(this.satisfyInit));
    },
    delSatisfyData(index) {
      this.satisfyList.splice(index, 1);
    },

    // 设置弹框请求数据
    setTableData(type) {
      if (type == "goods") {
        this.tableData.title = "商品列表";
        this.tableData.sqlType = "GoodsList";
        this.tableData.key = "sub_title";
        this.tableData.isAllSel = false;
      } else if (type == "area") {
        this.tableData.title = "区域列表";
        this.tableData.sqlType = "RegionListN";
        this.tableData.key = "地址";
        this.tableData.isAllSel = true;
      } else if (type == "user") {
        this.tableData.title = "用户列表";
        this.tableData.sqlType = "CompanyList";
        this.tableData.key = "单位名称";
        this.tableData.isAllSel = true;
      }
      this.tableData.type = type;
      this.getTableData();
    },

    // 获取弹出框表格数据
    getTableData(val, isRep) {
      this.tableData.searchForm.name = isRep
        ? val
        : this.tableData.searchForm.name;
      let data = {
        type: this.tableData.sqlType,
        PageIndex: this.currPageLimit,
        PageSize: 10,
        strWhere: this.tableData.searchForm.name,
      };
      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.tableList = res.content;
            this.tableDataHead = res.fdname;
            this.allPageLimit = res.recordCount;
            this.isShowLimit = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**当前页改变 */
    hanCurrChangeLimit(val) {
      this.currPageLimit = val;
      this.getTableData();
    },

    // 选择单条数据
    // rowClickLimit(row, isSelDataOk) {
    rowClickLimit(row) {
      if (this.tableData.type == "goods") {
        this.addForm.goodsId = row.keyid;
        this.addForm.entId = row.entId;
        this.addForm.goodsName = row[this.tableData.key];
      } else if (
        this.tableData.type == "area" ||
        this.tableData.type == "user"
      ) {
        // 去除重复数据判断
        // for (let i = 0; i < this[this.tableData.type + "List"].length; i++) {
        //   if (this[this.tableData.type + "List"][i].value == row.keyid) {
        //     if (isSelDataOk === true) {
        //       this.isSelDataOkRep = true;
        //     } else {
        //       this.$message({
        //         message: "选择的数据已在列表中",
        //         type: "warning",
        //       });
        //     }
        //     return;
        //   }
        // }
        this[this.tableData.type + "List"].push({
          label: row[this.tableData.key],
          value: row.keyid,
        });
        this.addForm[this.tableData.type + "Value"] = this[
          this.tableData.type + "List"
        ]
          .map((item) => item.value)
          .join();
      }
      this.isShowLimit = false;
    },

    // 选择数据完成，多选
    selDataOk(selectedList) {
      if (selectedList.length == 0) {
        this.$message({
          message: "请选择数据",
          type: "warning",
        });
        return;
      }
      selectedList.forEach((item) => {
        this.rowClickLimit(item, true);
      });
      // 去除重复数据判断
      // if (this.isSelDataOkRep) {
      //   this.$message({
      //     message: "选择的数据已在列表中",
      //     type: "warning",
      //   });
      //   this.isSelDataOkRep = false;
      // }
    },

    // 标签删除
    tagClose(index, key, keyList) {
      this[keyList].splice(index, 1);
      this.addForm[key] = this[keyList].map((item) => item.value).join();
    },

    // 控销控制验证
    limitFill(key) {
      return {
        validator: (rule, value, callback) => {
          if (this.addForm[key] != 0) {
            if (!value) {
              return callback(new Error("该字段为必填项"));
            } else {
              return callback();
            }
          } else {
            return callback();
          }
        },
      };
    },

    /**获取客户列表 */
    getGroupList() {
      let data = {
        entId: window.localStorage.getItem("entId"),
        status: "2",
        searchVal: "", //关键字
        pageIndex: 1,
        pageSize: 999,
      };

      this.$request({
        url: "Member/GetMemberGroup",
        method: "post",
        data,
      })
        .then((res) => {
          this.groupList = res.list;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**提交表单 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let scenarioId = "";
          if (this.addForm.goodsRange != 0) {
            let range = this.goodsRangeList.slice(1);
            scenarioId = range
              .map((item) =>
                [item.id, item.allNum, item.limitNum, item.minNum].join("_")
              )
              .join("|");
          }
          let list = this.satisfyList.slice(1);
          list = list.map((item) => {
            if (this.addForm.type == "DQG") {
              return {
                GoodsId: item.id || "0",
                shl: "1",
                Price: item.price || "0",
                Total: item.allNum || "0",
                MeetCount: item.needNum || "0",
                Limit: item.limitNum || "0",
              };
            } else if (this.addForm.type == "GZH") {
              return {
                GoodsId: item.id || "0",
                shl: item.allNum || "1",
                Price: item.price || "0",
                Total: "1",
                MeetCount: item.needNum || "0",
                Limit: item.limitNum || "0",
              };
            } else {
              return {
                mztj: item.needNum || "0",
                zk: item.discount || "100",
                zpmc: item.gift || "null",
                zpid: item.id || "0",
                shl: item.num || "0",
                jg: item.price || "0",
              };
            }
          });
          let data = {
            type: "SaveProm",
            entId: window.localStorage.getItem("entId"),
            faname: this.addForm.name,
            ruleCode: this.id,
            faType: this.addForm.type,
            customerType: this.addForm.userType.join(",") + ",",
            describe: this.addForm.des,
            Quantity: this.addForm.allNum,
            xgAmount: this.addForm.limitNum,
            qykzlx: this.addForm.limitArea, //限制类型
            qykzbh: this.addForm.areaValue, //区域编号
            qykzmc: this.areaList.map((item) => item.label).join(","), //区域名称
            lsid: JSON.stringify(list),
            pclx: this.addForm.customerLimit, //黑名单，白名单
            pckh: this.addForm.customerGroup.join(","), //客户分组
          };
          let url =
            "prom/ashx/PromGroupRule.ashx?json=" +
            encodeURIComponent(JSON.stringify(data));
          if (this.addForm.type != "DQG" && this.addForm.type != "GZH") {
            data.fabs = "";
            data.contentType = this.addForm.mode;
            data.JieTi = this.addForm.isAdd;
            data.ScenarioId = scenarioId;
            data.PromScenario = this.addForm.goodsRange;
            url =
              "prom/ashx/PromRule.ashx?json=" +
              encodeURIComponent(JSON.stringify(data));
            if (
              this.goodsRangeList.length <= 1 &&
              this.addForm.goodsRange != 0
            ) {
              this.$message({
                message: "请选择活动商品",
                type: "warning",
              });
              return;
            }
          }
          if (this.satisfyList.length <= 1) {
            this.$message({
              message: "请填写促销满足条件",
              type: "warning",
            });
            return;
          }
          this.$requestSys({
            method: "post",
            url: url,
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.goBack();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.addPromRule {
  width: 100%;
  height: 100%;
}
</style>
